import AuditLogRepository from "../repository/AuditLog.repository";

export default class AuditLog {
  static async getByDate(date) {
    return new Promise((resolve, reject) => {
      AuditLogRepository.getByDate(date)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }

  static async getByDocument(id) {
    return new Promise((resolve, reject) => {
      AuditLogRepository.getByDocument(id)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  }
}
